import { render } from "./PanelAvisosFormBorrar.vue?vue&type=template&id=4017f422"
import script from "./PanelAvisosFormBorrar.vue?vue&type=script&lang=ts"
export * from "./PanelAvisosFormBorrar.vue?vue&type=script&lang=ts"
script.render = render

export default script